<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title
            >Employee Appraisal Evaluation Report</v-toolbar-title
          >
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" xs="12" sm="2" lg="2" md="12">
            <p class="padding-bot"><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
            />
          </v-col>

           <!-- Select Department -->
           <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Select Department</b></p>
                    <v-autocomplete color="#0F2027" dense rounded v-model="selectedDepartment" 
                        :items="department_list" item-text="name" item-value="id" 
                        @change="filterInstructors" label="Department" outlined />
                </v-col>
                <!-- Select Employee Payment Section -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Employee Payment Section</b></p>
                    <v-autocomplete color="#0F2027" dense rounded v-model="selectedPaymentSection" 
                        :items="employee_payment_section_list" item-text="name" item-value="id" 
                        @change="filterInstructors" label="Payment Section" outlined />
                </v-col>

                 <!-- Filtered Instructor List -->
                <v-col cols="12" xs="12" sm="3" lg="3" md="12">
                    <p class="padding-bot"><b>Instructor List</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" 
                        @change="show=false" :items="filteredInstructorList" item-text="name" 
                        item-value="id" label="Instructor" outlined />
                </v-col>



          <!-- <v-col cols="12" xs="12" sm="2" lg="2" md="12">
            <p class="padding-bot"><b>Instructor List</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="instructor"
              :items="instructor_list"
              item-text="name"
              item-value="id"
              label="Instructor"
              outlined
            />
          </v-col> -->
          <v-col cols="12" xs="12" sm="2" lg="2" md="12">
            <p class="padding-bot"><b></b></p>
            <br />
            <v-btn
              class="toolbar"
              outlined
              dense
              rounded
              :loading="loader"
              @click="fetch()"
            >
              Fetch</v-btn
            >
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="appraisal_credit_list != ''">
        <v-data-table :headers="headers" :items="appraisal_credit_list">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Credit Evaluation</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <!-- <template v-slot:[`item.credit_point_obtained`]="{ item }">
        <v-text-field class="padding-bot" outlined dense type="number" v-model="item.credit_point_obtained"  :rules="[v => v <= item.max_marks || 'Marks should be Less Than Max Marks']" ></v-text-field>
        </template> -->
        </v-data-table>
        <!-- <v-row justify="center" dense v-if="!this.is_final_approved">
          <p style="color:red"> Marks Are Already Approved...</p>
         </v-row> -->
      </v-card>
      <v-card class="box" v-if="appraisal_parameter_evaluation_list != ''">
        <!-- data for table-- {{ appraisal_parameter_evaluation_list }}<br />
        {{ total_score }}<br />
        {{ max_total_score }}<br />
        {{ percentage }}<br /> -->

        <v-simple-table>
          <thead>
            <tr>
              <td
                v-for="(i, index) in appraisal_parameter_evaluation_list"
                :key="index"
                colspan="2"
              >
                {{ i.name }}
              </td>
              <td>Total Score</td>
              <td>Percentage</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-for="(i, index) in appraisal_parameter_evaluation_list"
                :key="index"
                colspan="2"
              >
                <span> {{ i.obtained_marks }} || {{ i.max_marks }}</span>
              </td>
              <!-- <td
                colspan="1"
                v-for="(i, index) in appraisal_parameter_evaluation_list"
                :key="index"
              >
                <span> {{ i.max_marks }}</span>
              </td> -->
              <td>{{ total_score }} || {{ max_total_score }}</td>
              <!-- <td>
                {{ max_total_score }}
              </td> -->
              <td>
                {{ percentage }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    department_list:[],
    employee_payment_section_list:[],
    selectedDepartment: null,
    selectedPaymentSection: null,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    instructor_list: [],
    instructor: "",
    ay_list: [],
    ay: "",
    appraisal_parameter_evaluation_list: [],
    total_score: 0,
    percentage: 0,
    max_total_score: 0,
    is_final_approved: false,
    headers: [
      { text: "Sr No", value: "srno" },
      { text: "Credit", value: "name" },
      { text: "Credit Points Alloted", value: "max_marks" },
      { text: "Credit Points Obtained", value: "credit_point_obtained" },
      { text: "Criteria", value: "criteria" },
    ],
  }),
  methods: {
    filterInstructors() {
            this.filteredInstructorList = this.instructor_list.filter(inst => {
                const matchesDepartment = this.selectedDepartment ? inst.department_id === this.selectedDepartment : true;
                const matchesPaymentSection = this.selectedPaymentSection ? inst.employeepaymentsection_id === this.selectedPaymentSection : true;
                return matchesDepartment && matchesPaymentSection;
            });
        },
    fetch() {
      this.overlay = true;
      this.loader = true;
      const formData = {
        ay: this.ay,
        instructor: this.instructor,
      };
      axios
        .post("/Appraisal/fetchEvaluationReport", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.appraisal_parameter_evaluation_list =
              res.data.appraisal_parameter_evaluation_list;
            this.appraisal_credit_list =
              res.data.instructor_appraisal_credit_list;
            this.max_total_score = res.data.cumulative_max_marks;
            this.total_score = res.data.cumulative_obtained_marks;
            this.percentage = res.data.percentage;
            this.is_final_approved = res.data.allowed_save;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
          // this.calculate_total_percentage()
        });
    },
    onLoad() {
      axios
        .post("/Appraisal/getHrEvaluationData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.instructor_list = res.data.instructor_list;
            this.ay_list = res.data.ay_list;
            this.ay = res.data.cay;
            this.department_list=res.data.department_list
            this.employee_payment_section_list=res.data.employee_payment_section_list
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!");
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {
        instructor_list: {
            handler() {
                this.filterInstructors();
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style scoped>
thead,
tr,
th {
  font-weight: bold !important;
  border: 1px solid black;
  font-size: 16px;
  text-align: center;
  /* height: 50px; */
}
tbody,
td {
  font-weight: bold !important;
  border: 1px solid black;
  /* font-size: large; */
  text-align: center;
  /* height: 50px; */
}
.vl {
  border-left: 6px solid green;
  height: 100%;
}
/* hr {
  height: 100vh;
  width: 0.5vw;
  border-width: 0;
  color: #000;
  background-color: #000;
} */
.rotated {
  transform: rotate(45deg); /* Equal to rotateZ(45deg) */
  background-color: pink;
}
</style>